/**
 * Session utility functions for LiveSessionInterface
 */

/**
 * Get CSS classes for session status badge
 * @param {string} status - Session status (pending, active, completed, cancelled)
 * @returns {string} CSS classes for the status badge
 */
export const getStatusColor = (status) => {
  const colors = {
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-700',
    active: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-700',
    completed: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600',
    cancelled: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700'
  };
  return colors[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

/**
 * Get status message for toast notifications
 * @param {string} status - Session status
 * @returns {string|null} Status message or null if no message
 */
export const getStatusMessage = (status) => {
  const statusMessages = {
    completed: '✅ Session completed',
    cancelled: '❌ Session cancelled',
    active: '🟢 Session is now active'
  };
  return statusMessages[status] || null;
};

/**
 * Format session status for display
 * @param {string} status - Session status
 * @returns {string} Formatted status string
 */
export const formatStatus = (status) => {
  if (!status) return '';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

